<template>
  <div class="producten container">
    <div
      v-if="products"
      class="producten">
      <h1>{{ categoryName }}</h1>
      <div class="columns is-multiline">
        <div
          v-for="product in products"
          :key="product._id"
          class="column is-4 products-product-container">
          <router-link :to="routerLink(product)">
            <div>{{ product.id }}</div>
            <p class="mb10"><strong>{{ product.name }} ({{ product.reference }})</strong></p>
            <div
              v-if="product.media[0]"
              :style="{ backgroundImage: 'url(' + `${product.media[0].location}` + ')' }"
              class="product-image-container">
              <span
                v-if="product.sold === 0"
                class="products-sold">
                {{ $t('Producten.sold') }}
              </span>
              <span
                v-if="(product.price && product.sold!==0)"
                class="products-price">
                &euro; {{ formatPrice(product.price) }}
              </span>
            </div>
          </router-link>
          <p v-if="product.brand">
            <span class="products-label">{{ $t('Producten.brand') }}:</span> {{ product.brand }}
          </p>
          <p v-if="product.type">
            <span class="products-label">{{ $t('Producten.type') }}:</span> {{ product.type }}
          </p>
          <br> <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Producten",
  props: {
    categoryId: {
      type: String,
      required: false,
      default: "0"
    },
    categoryName: {
      type: String,
      required: false,
      default: "Alle producten"
    }
  },
  computed: {
    ...mapGetters({
      products: "getProducts",
      productCategories: "getProductCategories",
      currentLanguage: "getCurrentLanguage"
    }),
    shouldDisplay() {
      return this.product.images[0].afbeelding !== "undifined";
    }
  },
  watch: {
    currentLanguage() {
      this.fetchProduct(this.productId);
    },
    $route() {
      this.fetchProducts(this.categoryId);
    }
  },
  created() {
    this.fetchProducts(this.categoryId);
  },
  methods: {
    ...mapActions({
      fetchProducts: "fetchProducts"
    }),
    getImagePath(image) {
      return image ? `https://vanhoutte-api.oakfields.be/assets/uploads/${image}` : "";
    },
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    routerLink(product) {
      if (product.sold === 0) return "#";
      return `/product/${product._id}/${product.name}`;
    }
  }
};

</script>

<style scoped lang="scss">
@import "../assets/css/style.scss";

h1 {
  color: $secundary;
  font-size: 32px;
  margin-top: 10px;
  margin-bottom: 40px;
}

.product-image-container {
  height: 250px;
  width: 350px;
  background-size: cover;
  margin-bottom: 20px;
}

.products-product-container {
  position: relative
}

.producten {
  margin-top: 40px;
  margin-bottom: 80px;
}

.products-label {
  font-weight: 800;
}

.mb10 {
  margin-bottom: 10px;
}

.products-image {
  max-height: 250px;
  margin-bottom: 10px;
}

span.products-price {
    margin-top: 14px;
    background: rgba(224, 73, 62, 0.8);
    padding: 5px 15px;
    color: #fff;
    position: relative;
    width: auto;
    float: right;
    margin-right: 14px;
}

span.products-sold {
    margin-top: 14px;
    background: rgba(224, 73, 62, 0.8);
    padding: 5px 15px;
    color: #fff;
    position: relative;
    width: auto;
    float: left;
    margin-left: 14px;
}

@media (max-width: 1087px) {
  .producten {
    margin: 40px 20px 80px;
  }
}

@media (max-width: 1279px) {
  .product-image-container {
    height: 180px;
    width: 250px;
  }
}

@media (max-width: 879px) {
  .product-image-container {
    height: 140px;
    width: 200px;
  }
}

@media (max-width: 768px) {
  .product-image-container {
    height: 250px;
    width: 350px;
  }
}

@media (max-width: 420px) {
  .product-image-container {
    height: 180px;
    width: 250px;
  }
}


</style>
